import { useState } from 'react';
import { ChevronDown, ChevronRight, AlertTriangle } from 'lucide-react';

/** Local spreadsheet rows that don't (yet) resolve to a real, live Zoho Deal —
 * kept visible for awareness only, collapsed by default. Nothing here is editable
 * or counted as real data until it gets a genuine CRM Deal link. */
export const SpellersUnmatchedSection = ({ projects }) => {
  const [open, setOpen] = useState(false);
  if (!projects.length) return null;

  return (
    <div className="mt-4 rounded-2xl border-2 border-amber-300 bg-amber-50 overflow-hidden" data-testid="spellers-unmatched-section">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
        data-testid="spellers-unmatched-toggle"
      >
        <span className="flex items-center gap-2 text-sm font-bold text-amber-800">
          <AlertTriangle className="w-4 h-4" /> Unmatched — needs a CRM Deal ({projects.length})
        </span>
        {open ? <ChevronDown className="w-4 h-4 text-amber-700" /> : <ChevronRight className="w-4 h-4 text-amber-700" />}
      </button>
      {open && (
        <div className="border-t-2 border-amber-300 divide-y divide-amber-200" data-testid="spellers-unmatched-list">
          {projects.map((p) => (
            <div key={p.id} className="px-4 py-2 flex items-center justify-between text-sm" data-testid={`spellers-unmatched-row-${p.id}`}>
              <span className="font-semibold text-gray-700">{p.project_name || p.project_id}</span>
              <span className="text-xs text-amber-700">No matching Zoho Deal found</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SpellersUnmatchedSection;
